import { DotsThree, PencilSimpleLine, Trash } from "@phosphor-icons/react";

import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";

import useConversationMessagesUpdates from "../../../datahooks/useConversationMessagesUpdates";
import { useConversationUrnContext } from "../ConversationUrnContext";

import type { ConversationMessage } from "../../../types";

interface MessageMenuProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  accountId: string;
  message: ConversationMessage;
  setEditMessage: (message: ConversationMessage) => void;
}

export default function MessageMenu({
  isOpen,
  setIsOpen,
  accountId,
  message,
  setEditMessage,
}: MessageMenuProps) {
  const conversationUrn = useConversationUrnContext();

  const { deleteMessage } = useConversationMessagesUpdates({
    conversationUrn,
  });

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger className="relative" asChild>
        <Button intent="iconOnly" size="xs" variant="ghost-black">
          <DotsThree />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        <DropdownMenuList>
          <RenderIf condition={!!message.body}>
            <DropdownMenuItem onClick={() => setEditMessage(message)}>
              <PencilSimpleLine />
              Edit message
            </DropdownMenuItem>
          </RenderIf>

          <DropdownMenuItem
            variant="danger"
            onClick={() =>
              deleteMessage({ accountId, messageUrn: message.urn })
            }
          >
            <Trash />
            Delete message
          </DropdownMenuItem>
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
